export enum ToastType {
    pass = 'pass',
    fail = 'fail',
    warning = 'warning',
    neutral = 'neutral',
    updateApp = 'update-app',
}

export interface Toast {
    createdOn?: number;
    text: string;
    type: ToastType;
    shouldFadeOutAutomatically?: boolean;
}
